import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'reflexbox';

import { Link } from '@treams/treams-routes';

import { IEitherNavigationLink } from 'packages/kakapo-ui-kit/types/Navigation';

interface IProps {
	link: IEitherNavigationLink;
	icon: ReactNode;
}

interface IElementProps {
	isActive?: boolean;
}

const Element = styled(Link)<IElementProps>`
	color: ${(props) => props.theme.colors.slateBlue};
	svg {
		/* Natural offset to align horizontally with the text line height. */
		transform: translateY(-2px);
		display: block;
		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	:hover {
		color: ${(props) => props.theme.colors.primary};
		svg path {
			fill: ${(props) => props.theme.colors.primary};
		}
	}

	${(props) =>
		props.isActive &&
		`
			color: ${props.theme.colors.primary};
			svg path {
				fill: ${props.theme.colors.primary};
			}
	`}
`;

export default function PlainIconNavigationLink({ link, icon }: IProps) {
	return (
		<Box ml={3}>
			<Element to={link.to!} isActive={link.isActive}>
				<Flex alignItems="center">
					<Box mr={2}>{icon}</Box>
					<Box>{link.title}</Box>
				</Flex>
			</Element>
		</Box>
	);
}
